

import CommonApi from './../commonApi';

const washingFrequency = new CommonApi(
  'washingFrequency',
  'Периодичность преведения моек ТС'
);

export default {
  ...washingFrequency
};
